

<mat-accordion class="example-headers-align">
    <ng-content></ng-content>
</mat-accordion>
